export const CALIBRATION_BOOKMARKLET_START_YEAR = 2020;
export const CALIBRATION_BOOKMARKLET_NAME = 'eBird Calibration for BirdMap Explorer';
export const STORED_COUNTABILITY_CALIBRATION_KEY = 'storedCountabilityCalibration';
export const STORED_COUNTABILITY_CALIBRATION_VERSION = 1;
